import AddHollow from '@clearkit/icons/glyphs/AddHollow';
import { CKBox, CKButton } from '@clearkit/react';

import { readableType } from '~/lib/dataEnrichment';

import EmptyState from '../EmptyState.svg';
import EmptyMappingStateHubspot from './EmptyMappingStateHubspot.svg';
import EmptyMappingStateSalesforce from './EmptyMappingStateSalesforce.svg';

const EmptyFieldMappingFields = ({
  addMapping,
  integration,
  objectType,
  hasEnrichmentBetaUIFlag,
}) => {
  return (
    <>
      {hasEnrichmentBetaUIFlag ? (
        <CKBox
          className="flex flex-col items-center p-10"
          variant={CKBox.Variant['tinted-frame']}>
          <EmptyStateIcon integration={integration} />
          <p className="text-base font-medium text-center text-gray-800 mt-7">
            Let's get {objectType.name} field mappings set up
          </p>
          <p className="max-w-md mt-2 text-sm text-center text-gray-600">
            To sync enriched data to {objectType.name}s in your{' '}
            {readableType(integration)} CRM, you’ll need to set up field
            mappings. Add your first mapping to get started.
          </p>
        </CKBox>
      ) : (
        <CKBox
          className="flex flex-col items-center p-10 m-10"
          variant={CKBox.Variant['tinted-frame']}>
          <EmptyState />
          <p className="text-base font-medium text-center text-gray-800 mt-7">
            Add your first mapping
          </p>
          <p className="max-w-md mt-2 text-sm text-center text-gray-600">
            There are no field mappings for enriching{' '}
            {readableType(integration)} {objectType.name}s, yet. Add your first
            mapping or address group to get started.
          </p>
          <div className="mt-6">
            <CKButton
              onClick={() => addMapping()}
              className="mr-4"
              leftIcon={<AddHollow />}>
              Add mapping
            </CKButton>
            <CKButton disabled leftIcon={<AddHollow />}>
              Add address group
            </CKButton>
          </div>
        </CKBox>
      )}
    </>
  );
};

function EmptyStateIcon({ integration }) {
  return (
    <>
      {integration === 'salesforce' ? (
        <EmptyMappingStateSalesforce />
      ) : (
        <EmptyMappingStateHubspot />
      )}
    </>
  );
}

export default EmptyFieldMappingFields;
